<template>
  <div id="app">
    <router-view></router-view>
    <ModalIdle v-if="isIdle"/>
  </div>
</template>

<script>

import ModalIdle from "./views/ModalIdle.vue";

export default {
  name: "app",
  components: {
    ModalIdle
  },
  data: () => ({}),
  methods: {},
  computed: {
    isIdle() {
      return this.$store.state.idleVue.isIdle;
    },
  },
};
</script>  